import SegmentationSelect from './segmentationSelect';

export default SegmentationSelect;
